import { css } from '@emotion/react';

const chargeFailStyles = {
    container: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'calc(100% - 4rem)',
        color: '#101010',
        height: '100%',
    }),
    info: css({
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 400,
        marginBottom: '30px',
        paddingTop: '56px',
    }),
    infoTitle: css({
        fontSize: '1.5rem',
        fontWeight: 800,
        textAlign: 'left',
        color: '#101010',
        margin: 0,
    }),
    description: css({
        color: '#000000',
        fontSize: '15px',
        lineHeight: '20px',
        marginTop: '0',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    }),
};

export default chargeFailStyles;
